(function () {
  function init() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    try {
      if (sessionStorage.getItem('ld:announcement:dismissed') === '1') {
        bar.style.display = 'none';
        return;
      }
    } catch (e) {}

    var msgs = bar.querySelectorAll('.announcement-bar__message');
    var rotateMs = parseInt(bar.getAttribute('data-rotate-ms'), 10) || 4000;

    if (msgs.length > 1) {
      var idx = 0;
      setInterval(function () {
        msgs[idx].classList.remove('is-active');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('is-active');
      }, rotateMs);
    }

    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        try { sessionStorage.setItem('ld:announcement:dismissed', '1'); } catch (e) {}
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
